import { useNavigate } from "react-router-dom";
import { useState } from "react";
import styled from "styled-components";
import Button from "../components/Button";
import Card from "../components/Card";
import Input from "../components/Input";
import { Stack } from "../components/Layout";
import PageShell from "../components/PageShell";
import { Heading, Text } from "../components/Typography";
import { apiPost, ApiError } from "../services/apiClient";
import { setSession } from "../services/authStorage";

const FormCard = styled(Card)`
  width: 100%;
`;

function SignIn() {
  const navigate = useNavigate();
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  async function signInSubmission(event) {
    event.preventDefault();

    if (!username.trim() || !password) {
      alert("Please enter a username and password.");
      return;
    }

    setLoading(true);
    try {
      const data = await apiPost(
        "/sign_in",
        { name: username, password },
        { skipAuth: true }
      );

      if (data.isGood === true) {
        setSession({ username, token: data.token });
        navigate("/UserDashboard");
      } else {
        alert("Invalid username or password.");
      }
    } catch (error) {
      const message =
        error instanceof ApiError
          ? error.message
          : "Sign in failed. Please try again.";
      alert(message);
    } finally {
      setLoading(false);
    }
  }

  return (
    <PageShell narrow>
      <FormCard padding={4}>
        <form onSubmit={signInSubmission}>
          <Stack $gap={4}>
            <Stack $gap={1}>
              <Heading $size="xl">Sign in</Heading>
              <Text $muted $size="sm">
                Enter your credentials to open the dashboard
              </Text>
            </Stack>
            <Stack $gap={3}>
              <Input
                label="Username"
                type="text"
                placeholder="Username"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
              />
              <Input
                label="Password"
                type="password"
                placeholder="Password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
              />
              <Button type="submit" disabled={loading}>
                {loading ? "Signing in..." : "Submit"}
              </Button>
            </Stack>
            <Button
              type="button"
              variant="ghost"
              onClick={() => navigate("/CreateUser")}
            >
              No account? Create a new user
            </Button>
          </Stack>
        </form>
      </FormCard>
    </PageShell>
  );
}

export default SignIn;
